export const readLocalStorage = (key: string) => {
	const item = window.localStorage.getItem(key);
	if (item === "null") return null;
	else return item;
};

export const writeLocalStorage = (key: string, data: string) => {
	window.localStorage.setItem(key, data);
};

export const removeLocalStorage = (key: string) => {
	window.localStorage.removeItem(key);
};

export const clearLocalStorage = () => {
	window.localStorage.clear();
};
